import { IConfigService } from '../../configuration/services/config.service';
import { ILoggingService } from '../../logging/logging.service';
import { UtilsMisc } from '../../utils/utils.misc';

export interface IBaseService {

    isInitialized: boolean;
    serviceId: string;

    initializeAsync(): Promise<void>;

}

export class BaseService implements IBaseService {

    protected _isInitialized = false;
    protected _serviceId: string = null;

    constructor(protected configurationService: IConfigService, protected loggingService: ILoggingService, autoInit: boolean = true) {
        this._serviceId = UtilsMisc.createGuid();

        this.loggingService.debug('BaseService --> constructor()');
        this.loggingService.debug('Service-ID: ' + this.serviceId);

        if (autoInit === true) {
            this.initializeAsync();
        }
    }

    public async initializeAsync(): Promise<void> {
        await this.doInitializeAsync();

        this._isInitialized = true;
    }

    public get isInitialized(): boolean {
        return this._isInitialized;
    }

    public get serviceId(): string {
        return this._serviceId;
    }

    protected async doInitializeAsync(): Promise<void> {
    }

}

